import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import Button from '@material-ui/core/Button';
import RenderSelectField from "../inputs/renderSelectField";
import MenuItem from '@material-ui/core/MenuItem';
import RenderTextField from "../inputs/renderTextField";

const CategoriesFilterForm =  (props) =>{
  const {filterCategory, handleSubmit, pillars, handleCancel} = props;
  return (
    <form onSubmit={handleSubmit(filterCategory)}>
      <div className={'form-group'}>
        <Field name="pillarId" label={'Pylon'} component={RenderSelectField} fullWidth>
          {
            pillars.map(pillar => (
              <MenuItem value={pillar.id} key={pillar.id}>{pillar.name}</MenuItem>
            ))
          }
        </Field>
      </div>
      <div className={'form-group'}>
        <Field name="weight" label={'Βαρύτητα'} component={RenderSelectField} fullWidth>
          <MenuItem value={'new'} >{'Νέα'}</MenuItem>
          <MenuItem value={'newComing'} >{'Υφιστάμενη'}</MenuItem>
          <MenuItem value={'old'} >{'Εξάμηνη'}</MenuItem>
        </Field>
      </div>
      <div className={'form-group'}>
        <Field name="name" label={'Name'} component={RenderTextField} type="text" fullWidth/>
      </div>
      <div className={'form-group'}>
        <Button type={'submit'} variant="contained" color="primary" className={'mr-3'}>
          {'Filter'}
        </Button>
        <Button onClick={handleCancel} variant="contained" color="secondary">
          {'Cancel'}
        </Button>
      </div>
    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'categoriesFilterForm',
})(CategoriesFilterForm);



// WEBPACK FOOTER //
// ./src/components/categories/categoriesFilterForm.js